module.exports = __webpack_public_path__ + "static/img/FR.ff2ed426.png";